<template>
    <form class="simulator-form">
        <div class="form-overflow">
            <div class="input-group">
                <div class="label"><i class="fal fa-table"/> Tabela de Vendas:</div>

                <div class="simulator-form-select">
                    <ui-select-v2
                        data-ui="simulation-select-change-sales-table"
                        v-model="form.data.sales_table_id"
                        :data="salesTableOptions"
                        :loading="loader.selectSalesTable"
                        :search="false"
                        align="right"
                        item-label="name"
                        return-value="id"
                        @input="salesTableSelectedHandler"
                    />
                </div>
            </div>

            <div class="input-group">
                <div class="label">Fluxo de Pagamento:</div>

                <div class="simulator-form-select">
                    <ui-select-v2
                        data-ui="simulation-select-change-sales-table-flow"
                        v-model="form.data.sales_table_flow_id"
                        :data="salesTableFlowOptions"
                        :loading="loader.selectSalesTableFlow"
                        :search="false"
                        align="right"
                        item-label="name"
                        return-value="id"
                        @input="salesTableFlowHandler"
                    />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { uiSelectV2 } from "@/components/ui/form"
    import { mapGetters } from 'vuex'

    export default {
        name: 'ui-simulator-form-sales-table',

        components: {
            uiSelectV2
        },

        data() {
            return {
                loader: {
                    selectSalesTable: false,
                    selectSalesTableFlow: false
                },

                form: {
                    fields: {},
                    data: {
                        sales_table_id: null,
                        salesTable: null,
                        sales_table_flow_id: null
                    }
                },
                unsubscribe: null,
                salesTableOptions: [],
                salesTableFlowOptions: []
            }
        },

        computed: {
            ...mapGetters('simulation', {
                simulationId: 'getSimulationId',
                product: 'getProduct',
                salesTable: 'getSalesTable',
                salesTableFlow: 'getSalesTableFlow',
                unity:'getUnity'
            })
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                /** Atualiza as opções de tabela de vendas de acordo com o produto */
                switch (mutation.type) {
                    /** Verifica se uma simulação está sendo carregada */
                    case 'simulation/CHECK_UNITY_SIMULATION':
                    case 'simulation/SET_SIMULATION':
                        this.loader.selectSalesTable = true
                        this.loader.selectSalesTableFlow = true
                        setTimeout(() => {
                            /** Carrega as opções do select das tabelas de vendas */
                            this.returnSalesTableOptions();
                            /** Verifica se uma tabela foi selecionada na simulação */
                            if (this.salesTable.id) {
                                let { salesTable, tableFlowId } = this.returnSalesTable();
                                /**
                                 * Caso a tabela selecionada não esteja nas opções, significa que esta foi removida ou
                                 * está expirada, neste caso inicia-se uma nova simulação com a primeira tabela disponível
                                 */
                                if (!salesTable) {
                                    this.$toastr.w('Tabela de vendas expirada/removida')

                                } else {
                                    this.returnFormSalesTable(salesTable);

                                    /** Verifica se um fluxo foi selecionado para a simulação */
                                    if (this.salesTableFlow && this.salesTableFlow.id) {
                                        let flow = this.salesTableFlowOptions.find(flow => parseInt(flow.id) === parseInt(this.salesTableFlow.id || tableFlowId));
                                        this.form.data.sales_table_flow_id = flow?.id || this.product.availability?.sales_table[0]?.sales_table_flow[0]?.id;
                                        this.$store.dispatch('simulation/setSalesTableFlow', flow)
                                        /**
                                         * Caso a simulação esteja sendo iniciada a partir da página de detalhes de uma unidade,
                                         * força o carregamento do fluxo
                                         */
                                        if (mutation.type === 'simulation/CHECK_UNITY_SIMULATION') this.$store.dispatch('simulation/generateSimulationSeries')
                                    }
                                }

                            } else if (!this.simulationId) {
                                /**
                                 * Caso nenhuma tabela de vendas tenha sido selecionada e não se estiver carregando uma
                                 * simulação já existente, carrega o primeiro fluxo da primeira tabela disponível
                                 */
                                this.loadInitialFlow()
                            }
                            /**
                             * Caso a simulação esteja sendo iniciada a partir da interna do negório, verifica se existem
                             * campos personalizados e gera as séries/parcelas
                             */
                            if (mutation.type === 'simulation/CHECK_UNITY_SIMULATION') this.$store.dispatch('simulation/generateCustomFieldsSeries')
                            this.loader.selectSalesTable = false
                            this.loader.selectSalesTableFlow = false
                        }, 500)
                        break

                    /** Verifica se um novo produto foi selecionado */
                    case 'simulation/SET_PRODUCT':
                        this.loader.selectSalesTable = true
                        setTimeout(() => {
                            /** Carrega as opções do select das tabelas de vendas */
                            if (this.product && Object.values(this.product.availability.sales_table).length) {
                                this.salesTableOptions = Object.values(this.product.availability.sales_table)

                            } else {
                                this.salesTableOptions = []
                                this.salesTableFlowOptions = []
                            }
                            this.loader.selectSalesTable = false
                            this.loadInitialFlow()
                        }, 500)
                        break

                    /** Verifica se uma nova unidade foi selecionada */
                    case 'simulation/SET_UNITY':
                        this.$store.dispatch('simulation/calcSeriesInitialValues')
                        break
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            /**
             * Carrega o primeiro fluxo da primeira tabela de vendas
             */
            loadInitialFlow() {
                this.loader.selectSalesTableFlow = true
                let flow = null
                /**
                 * Verifica se a disponibilidade do produto possui tabelas de vendas e
                 * carrega o primeiro fluxo da primeira tabela
                 */
                if (this.salesTableOptions.length) {
                    /** Pega a primeira tabela de vendas */
                    const salesTable = this.salesTableOptions[0]
                    this.form.data.salesTable = salesTable
                    this.form.data.sales_table_id = salesTable.id
                    this.$store.dispatch('simulation/setSalesTable', salesTable)
                    this.salesTableFlowOptions = Object.values(salesTable.sales_table_flow)

                    /** Pega o primeiro fluxo e gera as séries/parcelas */
                    flow = this.salesTableFlowOptions.find(option => parseInt(option.position) === 1)
                    if (flow && flow.id) this.form.data.sales_table_flow_id = flow.id
                }

                this.$store.dispatch('simulation/setSalesTableFlow', flow || {})
                this.$store.dispatch('simulation/generateSimulationSeries')
                this.loader.selectSalesTableFlow = false
            },

            /**
             * Trata o evento de quando uma tabela de vendas é selecionada, de modo a carregar os fluxos
             */
             salesTableSelectedHandler(value) {
                if(!value){
                    this.$store.dispatch('simulation/clearSalesTable').then(() => {
                        this.$store.dispatch('simulation/setDiscount', { discount: 0 })
                        this.$store.dispatch('simulation/setSalesTableFlow', {})
                        this.$store.dispatch('simulation/generateSimulationSeries')
                        this.salesTableFlowOptions = []
                        this.form.data.sales_table_id = null                    
                        this.form.data.sales_table_flow_id = null
                        this.loader.selectSalesTableFlow = false
                    })
                    return;
                } 
                // Verifica se o fluxo selecionado já está configurado no vuex para não recarregar o fluxo
                if (this.salesTable?.id && this.salesTable?.id === parseInt(value)) return

                this.salesTableFlowOptions = []
                this.form.data.sales_table_flow_id = null

                this.loader.selectSalesTableFlow = true
                if (parseInt(value)) {
                    setTimeout(() => {
                        const salesTable = Object.values(this.product.availability.sales_table).find(table => table.id === parseInt(value))
                        if(!salesTable) return;
                        if (salesTable && salesTable.id) {
                            this.salesTableFlowOptions = salesTable.sales_table_flow && Object.values(salesTable.sales_table_flow).length
                                ? Object.values(salesTable.sales_table_flow)
                                : []
                            this.form.data.salesTable = salesTable
                            this.$store.dispatch('simulation/setSalesTable', salesTable)
                            this.$store.dispatch('simulation/setDiscount', salesTable)
                            if (this.salesTableFlowOptions.length) {
                                /** Pega o primeiro fluxo e gera as séries/parcelas */
                                let flow = this.salesTableFlowOptions.find(option => parseInt(option.position) === 1)
                                if (flow && flow.id) this.form.data.sales_table_flow_id = flow.id
                                this.$store.dispatch('simulation/setSalesTableFlow', flow || null)
                                this.$store.dispatch('simulation/generateSimulationSeries')
                            } else {
                                /**
                                 * Se não possuir fluxo, envia um objeto vazio para a store
                                 * para que não envie os dados do fluxo da tabela de venda anterior
                                 */
                                this.$store.dispatch('simulation/setSalesTableFlow', {})
                                this.$store.dispatch('simulation/generateSimulationSeries')
                            }
                        }
                        this.loader.selectSalesTableFlow = false
                    }, 500)
                }
            },

            /**
             * Trata o evento de quando um fluxo é selecionado, de modo a gerar as séries
             */
            salesTableFlowHandler(value) {
                if (this.salesTableFlow?.id && this.salesTableFlow?.id === parseInt(value)) return

                if (parseInt(value)) {
                    if (this.form.data.salesTable && this.form.data.salesTable.id) {
                        const flow = Object.values(this.form.data.salesTable.sales_table_flow).find(flow => flow.id === parseInt(value))
                        this.$store.dispatch('simulation/setSalesTableFlow', flow)
                        this.$store.dispatch('simulation/generateSimulationSeries')

                    } else {
                        this.$toastr.e('A tabela de vendas selecionada não existe')
                    }

                } else {
                    this.form.data.sales_table_flow_id = null
                    this.$store.dispatch('simulation/setSalesTableFlow', null)

                    setTimeout(() => {
                        this.$toastr.e('Selecione um fluxo válido')
                    }, 500)
                }
            },
            /** Trata a situação da tabela de vendas, conforme empreendimento selecionado, caso troque de tabela porque houve troca de produto retorna a primeira tabela e fluxo de tabela do produto novo */
            returnSalesTable(){
                if(parseInt(this.product.availability_id) != parseInt(this.unity.availability_id)) {
                    return {'salesTable': this.product?.availability?.sales_table[0] ?? [], 'tableFlowId':this.product?.availability?.sales_table[0]?.sales_table_flow[0]?.id ?? 0};
                };
                let table = this.salesTableOptions.find(table => parseInt(table.id) === parseInt(this.salesTable.id));
                if (!table) table = this.salesTableOptions[0] || [];
                if(table.length == 0){
                    this.$store.dispatch('simulation/removeAllSimulationSeries', []);
                    this.loader.selectSalesTable = false;
                    this.loader.selectSalesTableFlow = false;
                }
                return {'salesTable': table,'tableFlowId': this.product.availability?.sales_table[0]?.sales_table_flow[0]?.id  || 0 }
            },
            /**Retorna as opções das tabelas no select da simulação */
            returnSalesTableOptions() {
                if (this.product?.availability?.sales_table) {
                    this.salesTableOptions = Object.values(this.product.availability.sales_table)
                } else {
                    this.salesTableOptions = []
                    this.salesTableFlowOptions = []
                }
            },
            /**Insere no formulário da tela a tabela de vendas pra serem enviadas  */
            returnFormSalesTable(salesTable){
                if(!salesTable) return;
                this.form.data.salesTable = salesTable
                this.form.data.sales_table_id = salesTable.id
                /** Seta os dados completos da tabela de vendas no state do vuex */
                this.$store.dispatch('simulation/setSalesTable', salesTable)
                /** Caso a tabela de vendas possua fluxos, carrega o fluxo selecionado */
                if (this.form.data.salesTable.sales_table_flow) {
                    this.salesTableFlowOptions = Object.values(this.form.data.salesTable.sales_table_flow)
                }
            },

            submit() {
                this.$emit('change')
            },
        }

    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>